import { computed } from "vue";
export function isDark(dark) {
  return dark ? "dark" : "light";
}
export const isIOS = computed(() => {
  return /iPad|iPhone|iPod/.test(navigator?.userAgent);
});
export function removeInvisibleCharacters(text) {
  if (!text) return;
  return text.replace(/[\u200B-\u200F\u202A-\u202E\u2060-\u2064\uFEFF]/g, "");
}
